import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const CarpetIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-carpet"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="24 12 43 12 43 9 24 9"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="21 26 43 26 43 12 21 12"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="24 29 43 29 43 26 24 26"
        />
        <g
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          transform="translate(14 1)"
        >
          <path d="M34 21C30.6867153 21 28 23.6867153 28 27 28 30.3132847 30.6867153 33 34 33 37.3132847 33 40 30.3132847 40 27 40 23.6867153 37.3132847 21 34 21ZM34 23C36.2087153 23 38 24.7912847 38 27 38 29.2087153 36.2087153 31 34 31 31.7912847 31 30 29.2087153 30 27 30 24.7912847 31.7912847 23 34 23ZM34-1C37.2379828-1 39.8775529 1.5659796 39.9958609 4.77508933L40 5 38 5C38 2.79128475 36.2087153 1 34 1 31.8582155 1 30.108946 2.68436693 30.0048964 4.80039588L30 5 28 5C28 1.68671525 30.6867153-1 34-1Z" />
          <polygon points="40 5 40 27 38 27 38 5" />
          <polygon points="30 5 30 27 28 27 28 5" />
          <polygon points="4 3 4 33 2 33 2 3" />
          <polygon points="29 3 29 5 3 5 3 3" />
          <polygon points="2 4 2 5 0 5 0 4" />
          <polygon points="34 31 34 33 3 33 3 31" />
          <polygon points="2 6 2 7 0 7 0 6" />
          <polygon points="2 8 2 9 0 9 0 8" />
          <polygon points="2 10 2 11 0 11 0 10" />
          <polygon points="2 12 2 13 0 13 0 12" />
          <polygon points="2 14 2 15 0 15 0 14" />
          <polygon points="2 16 2 17 0 17 0 16" />
          <polygon points="2 18 2 19 0 19 0 18" />
          <polygon points="2 20 2 21 0 21 0 20" />
          <polygon points="2 22 2 23 0 23 0 22" />
          <polygon points="2 24 2 25 0 25 0 24" />
          <polygon points="2 26 2 27 0 27 0 26" />
          <polygon points="2 28 2 29 0 29 0 28" />
          <polygon points="2 30 2 31 0 31 0 30" />
          <polygon points="2 32 2 33 0 33 0 32" />
        </g>
      </g>
    </Icon>
  )
}
